import React, { useCallback } from 'react';
import { fetchDBUDataWithFiltersData } from 'service/service';
import AdbFlatTableBase, { AdbServiceParams } from './AdbFlatTableBase';

/**
 * TotalDBUDetails component refactored to use AdbFlatTableBase.
 * This significantly reduces code duplication (by >90%) and improves maintainability.
 */
const TotalDBUDetails = () => {
  const serviceFunc = useCallback((params: AdbServiceParams) => {
    const {
      startDate, endDate, env, sector, location,
      page, pageSize, apiFilters, selectedDateInString, exportType,
      sortBy, sortDir
    } = params;
    return fetchDBUDataWithFiltersData({
      startDate,
      endDate,
      env,
      sector,
      location,
      page,
      pageSize,
      filters: apiFilters,
      selectedDateInString,
      workspaceName: undefined,
      exportType,
      sortField: sortBy,
      sortOrder: sortDir
    });
  }, []);

  return (
    <AdbFlatTableBase
      serviceFunc={serviceFunc}
      pageTitle="Total DBU Details"
      breadcrumbLabel="Databricks Analysis"
      breadcrumbPath="/databricksADB/workspace"
      tableType="total-dbu-details"
      preserveFilterKey="total_dbu_details_table"
    />
  );
};

export default TotalDBUDetails;